import InlineIconText from './InlineIconText';

export { type InlineIconTextProps } from './InlineIconText';
export default InlineIconText;
